import Illusion from 'illusionjs'
import Model from '../Model'
import HasOneOrMany from './HasOneOrMany'

export class HasMany extends HasOneOrMany {

    public match(currentModels: Model[], relativeModels: Model[], relativeName: string): boolean {

		return this.matchOneOrMany(currentModels, relativeModels, relativeName, 'many')
	}

	public create<A = any>(attributes?: A): Model {

		const currentModel = this.getCurrentModel()

		const relativeModel = new (this.getRelativeModel() as any).constructor

		const foreignKey = this.getForeignkey()

		return Object.assign(relativeModel, { [foreignKey]: currentModel.getPrimaryKeyId(), ...attributes})
	}
}

export default Illusion<typeof HasMany>(HasMany)